import type { IconData } from '@stacksjs/iconify-core'

export const dashboard: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M443 108q-29-11-60-16t-66 0q-49 6-90 29t-71 58t-46 80t-17 94v15q0 10-7 16t-17 7H23q-10 0-16-7t-7-16v-14q0-66 23-127t63-108t96-79T303 0q58-8 112 3t100 37q5 4 6 10t-5 10q-14 11-33 25t-29 22q-6 4-11 1m218 89q34 70 34 148v23q0 10-7 16t-17 7h-45q-10 0-17-7t-7-16v-23q0-37-11-75q-2-7 2-11l49-64q4-5 11-5t8 7m-87-64q8-6 16-5t14 6t7 14t-5 17L403 433l-3 3l-3 4q-21 20-50 20t-49-20t-20-49t20-49q2-2 4-3t4-3z\"/>",
  "width": 700,
  "height": 700,
  "viewBox": "0 0 700 700"
}

export default dashboard
